const earthRadiusKm = 6371;

function getRingAreaKm2(coordinates) {
  if (coordinates.length < 3) return 0;

  const ringArea = coordinates.reduce((area, coordinate, index) => {
    const nextCoordinate = coordinates[(index + 1) % coordinates.length];
    const longitude = coordinate[0] * (Math.PI / 180);
    const nextLongitude = nextCoordinate[0] * (Math.PI / 180);
    const latitude = coordinate[1] * (Math.PI / 180);
    const nextLatitude = nextCoordinate[1] * (Math.PI / 180);

    return area + (nextLongitude - longitude) * (Math.sin(latitude) + Math.sin(nextLatitude));
  }, 0);

  return Math.abs(ringArea) * earthRadiusKm ** 2 / 2;
}

function getPolygonAreaKm2(coordinates) {
  if (!coordinates?.length) return 0;

  return Math.max(
    getRingAreaKm2(coordinates[0])
    - coordinates.slice(1).reduce((area, ring) => area + getRingAreaKm2(ring), 0),
    0,
  );
}

function getGeometryAreaKm2(geometry) {
  if (geometry?.type === 'Polygon') {
    return getPolygonAreaKm2(geometry.coordinates);
  }

  if (geometry?.type === 'MultiPolygon') {
    return geometry.coordinates.reduce(
      (area, polygon) => area + getPolygonAreaKm2(polygon),
      0,
    );
  }

  return undefined;
}

function getGeometryBounds(geometry) {
  if (!geometry?.coordinates) return undefined;

  const bounds = [
    [Infinity, Infinity],
    [-Infinity, -Infinity],
  ];

  const visitCoordinates = (coordinates) => {
    if (typeof coordinates[0] === 'number') {
      bounds[0][0] = Math.min(bounds[0][0], coordinates[0]);
      bounds[0][1] = Math.min(bounds[0][1], coordinates[1]);
      bounds[1][0] = Math.max(bounds[1][0], coordinates[0]);
      bounds[1][1] = Math.max(bounds[1][1], coordinates[1]);
      return;
    }

    coordinates.forEach(visitCoordinates);
  };

  visitCoordinates(geometry.coordinates);

  return Number.isFinite(bounds[0][0]) ? bounds : undefined;
}

function getFeaturesBounds(features) {
  const bounds = [
    [Infinity, Infinity],
    [-Infinity, -Infinity],
  ];

  features.forEach((feature) => {
    const featureBounds = getGeometryBounds(feature?.geometry);
    if (!featureBounds) return;

    bounds[0][0] = Math.min(bounds[0][0], featureBounds[0][0]);
    bounds[0][1] = Math.min(bounds[0][1], featureBounds[0][1]);
    bounds[1][0] = Math.max(bounds[1][0], featureBounds[1][0]);
    bounds[1][1] = Math.max(bounds[1][1], featureBounds[1][1]);
  });

  return Number.isFinite(bounds[0][0]) ? bounds : undefined;
}

export {
  getFeaturesBounds,
  getGeometryAreaKm2,
  getGeometryBounds,
};
